import React from 'react';
import {NavList} from "../Header";

const NavItem = ({item, clickVoiceHandler}: { item: NavList, clickVoiceHandler: (name: string) => void }) => {
    return (
        <li className="nav-item dropdown">
            {item?.child && item.child.length ?
                <a className={'nav-link dropdown-toggle'} href="#"
                   role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {item.label}
                </a> :
                <a className={'nav-link'} href="#" role="button" onClick={() => clickVoiceHandler(item.name)}>
                    {item.label}
                </a>
            }
            {item?.child && item.child.length > 0 &&
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    {item?.child?.map((item: any, k: number) => (
                        <NavItem item={item} key={k} clickVoiceHandler={clickVoiceHandler}/>
                    ))
                    }
                </ul>
            }
        </li>
    );
};

export default NavItem;
